import { CLOCK_SKEW_ERROR_CODES, THROTTLING_ERROR_CODES, TRANSIENT_ERROR_CODES, TRANSIENT_ERROR_STATUS_CODES } from "./constants";
export var isRetryableByTrait = function isRetryableByTrait(error) {
  return error.$retryable !== undefined;
};
export var isClockSkewError = function isClockSkewError(error) {
  return CLOCK_SKEW_ERROR_CODES.includes(error.name);
};
export var isThrottlingError = function isThrottlingError(error) {
  var _a;

  return THROTTLING_ERROR_CODES.includes(error.name) || ((_a = error.$retryable) === null || _a === void 0 ? void 0 : _a.throttling) == true;
};
export var isTransientError = function isTransientError(error) {
  var _a;

  return TRANSIENT_ERROR_CODES.includes(error.name) || TRANSIENT_ERROR_STATUS_CODES.includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};